import * as React from "react"
import { GripVerticalIcon } from "lucide-react"
import * as ResizablePrimitive from "react-resizable-panels"
import type { ImperativePanelGroupHandle, PanelGroupProps } from "react-resizable-panels"

import { cn } from "@/lib/utils"

// Simplified resizable components that work with the current React version
export const ResizablePanelGroup = React.forwardRef<
  ImperativePanelGroupHandle,
  PanelGroupProps
>((props, ref) => {
  const { className, children, direction = "horizontal", ...rest } = props
  
  return (
    <ResizablePrimitive.PanelGroup
      ref={ref}
      className={cn(
        "flex h-full w-full",
        direction === "vertical" && "flex-col",
        className
      )}
      direction={direction}
      {...rest}
    >
      {children}
    </ResizablePrimitive.PanelGroup>
  )
})
ResizablePanelGroup.displayName = "ResizablePanelGroup"

export function ResizablePanel(props) {
  const { className, children, ...rest } = props
  
  return (
    <ResizablePrimitive.Panel
      className={cn('relative h-full w-full overflow-auto', className)}
      {...rest}
    >
      {children}
    </ResizablePrimitive.Panel>
  )
}

export function ResizableHandle(props) {
  const { className, withHandle = false, ...rest } = props
  
  return (
    <ResizablePrimitive.PanelResizeHandle
      className={cn(
        'bg-border relative flex w-px items-center justify-center',
        'data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full',
        // "transition-colors duration-150 ease-in-out",
        className
      )}
      {...rest}
    >
      {withHandle && (
        <div className="z-10 flex h-4 w-3 items-center justify-center rounded-sm border bg-border">
          <GripVerticalIcon className="h-2.5 w-2.5" />
        </div>
      )}
    </ResizablePrimitive.PanelResizeHandle>
  )
} 